/**
 * Filtre d’état des tâches (fiche dossier, onglet Tâches).
 * Isolé pour rester testable sans jsdom.
 */

export type TaskCompletionFilter = 'active' | 'completed' | 'all';

export const TASK_COMPLETION_FILTERS: {
  key: TaskCompletionFilter;
  label: string;
}[] = [
  { key: 'completed', label: 'Terminées' },
  { key: 'active', label: 'En cours' },
  { key: 'all', label: 'Tout' },
];

/** Défaut : masquer les tâches déjà faites. */
export const DEFAULT_TASK_COMPLETION_FILTER: TaskCompletionFilter = 'active';

export function completionToTaskFilters(
  filter: TaskCompletionFilter,
): { completed?: boolean } {
  if (filter === 'active') return { completed: false };
  if (filter === 'completed') return { completed: true };
  return {};
}
